// client平台特有代码
// console.warn("platform:pc");
import Vue from 'vue'
import elementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/less'
Vue.use(elementUI)
